import { render, staticRenderFns } from "./theme-seting.vue?vue&type=template&id=37f2e45e"
import script from "./theme-seting.vue?vue&type=script&lang=ts"
export * from "./theme-seting.vue?vue&type=script&lang=ts"
import style0 from "./theme-seting.vue?vue&type=style&index=0&id=37f2e45e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports